import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import moment from 'moment'
import 'moment/locale/es'  

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Chip from '@material-ui/core/Chip';
import Popover from '@material-ui/core/Popover';
import { Grid } from '@material-ui/core';

// Shared components
import PortletContent from 'components/PortletContent';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {getAvailabilityWeighted} from '../../../../../services/getWeighted'
import NoActiveSection from '../../../../../helpers/NoActiveSection'
import { Button } from '@material-ui/core';
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class AvailabilityWeighted extends Component {

    constructor(props) {
        super(props);
        //console.log('weighted props',props)
        this.state = {
            externalData: null,
            dataError: false,
            isLoading: true,
            objective:this.props.objective,
            steps:this.props.steps,
            token:sessionStorage.getItem('key'),
            user:sessionStorage.getItem("user"),
            begin:this.props.begin,
            final:this.props.final,
            period:this.props.namePeriod,
            newList:[],
            weightedList:[],
            Weighing:this.props.Weighing,
            open: false,
        }
    }

    componentDidMount() {
        // Intenta Obtener datos desde la API
        this.getDataFromAPI();
    }

    static getDerivedStateFromProps(props, state) {
        //console.log('derived', props.Weighing)
        if (props.namePeriod !== state.period || props.begin !== state.begin || props.final !== state.final) {
            return {
                externalData: null,
                dataError: false,
                isLoading: true,
                objective:props.objective,
                Weighing:props.Weighing,
                steps:props.steps,
                token:sessionStorage.getItem('key'),
                user:sessionStorage.getItem("user"),
                begin:props.begin,
                final:props.final,
                period:props.namePeriod,
                newList:[]
            }
        
        }
        return null
    }
    componentDidUpdate(prevProps, prevState) {
        //console.log('up', this.state.period,prevState.period )
        if(this.state.period!==prevState.period || this.props.begin !== prevState.begin || this.props.final !== prevState.final){
            //console.log('process')
            this.getDataFromAPI();
        }
        if(this.state.newList.length===this.state.steps.length*24&&this.state.isLoading===true){
            
            this.processData()
        }
    }

    getFetchs = (objective, begin, final, steps, user, token) =>{
        
        return new Promise((resolve, reject) => {
            var List = []
            var fetches = []  
            steps.map((step, key)=>{
                var getStep=getAvailabilityWeighted(objective, begin, final, step.id_paso, user, token)
                fetches.push(                    
                    getStep.then( data =>  { 
                        List[key] = data;
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(List);
            })      
        });
    }


    getDataFromAPI = () => {
        const {objective, begin, final, steps, user, token}=this.state
        var listStepsData = []
        var fetch= this.getFetchs(objective, begin, final, steps, user, token)
        fetch.then( value =>{
            if(value[0].data_pasos.length===0){
                this.setState({
                    dataError:true,
                    isLoading:false
                })
            }else{
                value.map(step=>{
                    //console.log(step)
                    step.data_pasos[0].data.map(data=>{
                        //console.log(data.desde.split("T")[1])
                        //console.log(data.desde)
                        data.desde=((moment('2020-04-01 '+data.desde+':00:00').locale('es')).format("HH:mm:ss"))
                        data.hasta=((moment('2020-04-01 '+data.hasta+':00:00').locale('es')).format("HH:mm:ss"))
                        var dictStep={paso:step.paso.nombre, inicio: data.desde, termino: data.hasta, uptime: data.dataHour.uptime.toFixed(2),
                                     downtimeP: data.dataHour.parcial.toFixed(2), downtime:data.dataHour.downtime.toFixed(2), noMon:data.dataHour.no_monitoreo.toFixed(2),
                                     evCli:data.dataHour.evento_cliente.toFixed(2),uptimeReal: data.dataHour.uptime, downtimePReal: data.dataHour.parcial, 
                                     downtimeReal:data.dataHour.downtime, noMonReal:data.dataHour.no_monitoreo, evCliReal:data.dataHour.evento_cliente}
                        listStepsData.push(dictStep)
                    })
                })
                this.setState({
                    newList: listStepsData
                })
            }
        })
    }

    processData=()=>{
        const {newList, Weighing}=this.state
        var listWeighted=[]
        newList.map(dataSteps=>{
            Weighing.map(weighted=>{

                if (weighted.valor == 100) {
                    dataSteps["valor"] = weighted.valor
                    dataSteps["valorPonde"] = 0
                    listWeighted.push(dataSteps)
                }else{
                    if(weighted.inicio===dataSteps.inicio){
                        dataSteps["valor"]=weighted.valor
                        dataSteps["valorPonde"]=weighted.valor
                        listWeighted.push(dataSteps)
                    }
                }
            })
        })
        //console.log('estado pond', listWeighted)
        this.setState({
            listSteps:listWeighted,
            isLoading:false
            
        })
    }

    onOpenPop = (e) => {
        const {listSteps} = this.state
        //console.log(e.currentTarget.value)
        var down=0
        var parcial=0
        var uptime=0
        var noMon=0
        var evCli =0
        listSteps.map(step=>{
            if (step.valor == 100) {
                if(step.paso===e.currentTarget.value){
                    uptime= uptime + step.uptimeReal
                    parcial=parcial + step.downtimePReal
                    down=down + step.downtimeReal
                    noMon=noMon + step.noMonReal
                    evCli=evCli + step.evCliReal
                }
            }else{    
                if(step.paso===e.currentTarget.value){
                    uptime=uptime+((step.valor/100)*step.uptimeReal)
                    parcial=parcial+((step.valor/100)*step.downtimePReal)
                    down=down+((step.valor/100)*step.downtimeReal)
                    noMon=noMon+((step.valor/100)*step.noMonReal)
                    evCli=evCli+((step.valor/100)*step.evCliReal)

                }
                
            }
        })

        if (listSteps[0].valor == 100) {
            uptime = (uptime.toFixed(2)/24).toFixed(2)
            parcial = (parcial.toFixed(2)/24).toFixed(2)
            down = (down.toFixed(2)/24).toFixed(2)
            noMon = (noMon.toFixed(2)/24).toFixed(2)
            evCli = (evCli.toFixed(2)/24).toFixed(2)

            var sum = parseFloat(uptime)+parseFloat(parcial)+parseFloat(down)+parseFloat(noMon)+parseFloat(evCli)
        }else{
            var sum = parseFloat(uptime.toFixed(2))+parseFloat(parcial.toFixed(2))+parseFloat(down.toFixed(2))+parseFloat(noMon.toFixed(2))+parseFloat(evCli.toFixed(2))
        }
        
        if(sum > 100){
            var exceso = sum.toFixed(2) - 100 
            uptime =  parseFloat(uptime) -  parseFloat(exceso.toFixed(2))
        }
            
        if(100 > sum){
            var deficit = 100 - sum.toFixed(2)
            uptime = parseFloat(uptime) + parseFloat(deficit.toFixed(2))
        }

        if (listSteps[0].valor == 100) {
            this.setState({
                open: true,
                weightedList:{"step":e.currentTarget.value,"uptime":uptime, "parcial":parcial, "downtime":down,"noMon": noMon, "evCli": evCli}
            });
        }else{
            this.setState({
                open: true,
                weightedList:{"step":e.currentTarget.value,"uptime":uptime.toFixed(2), "parcial":parcial.toFixed(2), "downtime":down.toFixed(2),"noMon": noMon.toFixed(2),"evCli": evCli.toFixed(2)}
            });
        }
    };
    onClosePop = () => {
        this.setState({ open: false });
    };

    render() {
        const {listSteps, isLoading, steps, open, dataError}=this.state
        if(isLoading===true){
            return (
                <PortletContent>
                    <PerfectScrollbar style={{position:"static"}}>
                        <Typography
                            variant="h5"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}                            
                            />
                            <br/>
                            Cargando Información...
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            )
        }else if(dataError===true){
            return (
                <PortletContent style={{paddingBottom:"36px"}}>
                    <NoActiveSection/>
                </PortletContent>
            )
            
        }else{
            //console.log('render', this.state.weightedList)
            return (
                <MaterialTable
                    icons={tableIcons}
                    columns={[
                        { title: "Paso", field: "paso",defaultGroupOrder: 0 },
                        { title: "Hora Inicio", field: "inicio"/*, type: "numeric"*/ },
                        { title: "Hora Termino", field: "termino"/*, type: "numeric"*/},
                        { title: "ponderado (%)", field: "valorPonde"/*, type: "numeric"*/},
                        { title: "Uptime (%)", field: "uptime"/*, type: "numeric"*/ },
                        { title: "Downtime Parcial (%)", field: "downtimeP"/*, type: "numeric"*/},
                        { title: "Downtime (%)", field: "downtime"/*, type: "numeric"*/},
                        { title: "Sin Mon. (%)", field: "noMon"/*, type: "numeric"*/}, 
                        { title: "Evento Cli. (%)", field: "evCli"/*, type: "numeric"*/}, 
                    ]}
                    components={{
                        Toolbar: props => (
                          <div>
                            <div style={{padding: '0px 10px'}}>
                                {steps.map(step=>(
                                    <div>
                                    <Button onClick={this.onOpenPop} value={step.nombre_paso}>
                                        <Chip label={'acumulado '+step.nombre_paso} style={{marginRight: 5}}/>
                                    </Button>
                                    <Popover open={open} 
                                        onClose={this.onClosePop} 
                                        anchorOrigin={{vertical: 'center', horizontal: 'center'}}
                                        transformOrigin={{vertical: 'center', horizontal: 'center' }}>
                                            <Grid container spacing={1}>
                                                <Grid
                                                    item
                                                    sm={12}
                                                    xl={12}
                                                    xs={12}
                                                    style={{textAlign:"center"}}
                                                >
                                                    <Typography variant="h4">Total  Acumulado {this.state.weightedList.step}</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={2}
                                                    xl={2}
                                                    xs={2}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h5">Uptime (%)</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={2}
                                                    xl={2}
                                                    xs={2}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h5">Downtime Parcial (%)</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={2}
                                                    xl={2}
                                                    xs={2}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h5">Downtime (%)</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={3}
                                                    xl={3}
                                                    xs={3}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h5">No Monitoreo (%)</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={3}
                                                    xl={3}
                                                    xs={3}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h5">Evento Cliente (%)</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={2}
                                                    xl={2}
                                                    xs={2}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="caption">{this.state.weightedList.uptime}</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={2}
                                                    xl={2}
                                                    xs={2}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="caption">{this.state.weightedList.parcial}</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={2}
                                                    xl={2}
                                                    xs={2}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="caption">{this.state.weightedList.downtime}</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={3}
                                                    xl={3}
                                                    xs={3}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="caption">{this.state.weightedList.noMon}</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={2}
                                                    xl={2}
                                                    xs={2}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="caption">{this.state.weightedList.evCli}</Typography>
                                                </Grid>
                                            </Grid>
                                    </Popover>
                                    </div>
                                ))}
                            </div>
                          </div>
                        ),
                      }}
                    data={listSteps}
                    title=""
                    localization={{
                        grouping: {
                            groupedBy: 'Agrupar por:',
                            placeholder: 'Arrastre los encabezados aquí, para agrupar',
                        },
                        body: {
                        emptyDataSourceMessage: 'No hay datos'
                        },
                        toolbar: {
                        searchTooltip: 'Buscar'
                        },
                        pagination: {
                        labelRowsSelect: 'Filas',
                        labelDisplayedRows: ' {from}-{to} de {count}',
                        firstTooltip: 'Pri. pág.',
                        previousTooltip: 'Pág. previa',
                        nextTooltip: 'Sig. pág.',
                        lastTooltip: 'Últ. pág'
                        }
                    }}
                    options={{
                        grouping: true
                    }}
                >
                    
                </MaterialTable>
            )
        }
    }
}


export default withRouter(AvailabilityWeighted);